<!-- Create a template reference to the outlet directive with the template variable assignment #outlet="outlet".
With this reference to the outlet directive, we can get the information of when the router outlet is active to trigger our animations. -->
<div class="route-fade-wrapper" [class.route-fade-active]="isRouteAnimating">
  <router-outlet #outlet="outlet" (activate)="onActivate($event)"></router-outlet>
</div>
